import { confirmDialog } from "primereact/confirmdialog";

import { Customer, Product } from "@/_services/invoiceService";

export interface ConfirmationData {
  quoteOption: "existing" | "new";
  selectedQuote?: string;
  selectedCustomer: Customer;
  selectedProducts?: Array<{
    product: Product;
    quantity: number;
  }>;
  totalAmount?: number;
  isCustomerAutoSelected?: boolean;
}

interface QuoteAssociationConfirmDialogProps {
  data: ConfirmationData;
  onConfirm: () => void;
  onCancel?: () => void;
}

export const useQuoteAssociationConfirmDialog = () => {
  const showConfirmDialog = ({
    data,
    onConfirm,
    onCancel,
  }: QuoteAssociationConfirmDialogProps) => {
    const isExistingQuote = data.quoteOption === "existing";
    const customerInfo = data.isCustomerAutoSelected 
      ? `Client: ${data.selectedCustomer.name} (sélectionné automatiquement depuis le devis)`
      : `Client: ${data.selectedCustomer.name}`;
    
    const summaryMessage = isExistingQuote
      ? `Voulez-vous associer cette commande au devis existant ?\n\n` +
        `${customerInfo}\n` +
        `Devis: ${data.selectedQuote}`
      : `Voulez-vous créer un nouveau devis pour cette commande ?\n\n` +
        `${customerInfo}\n` +
        `Nombre de produits: ${data.selectedProducts?.length || 0}\n` +
        `Montant total: ${data.totalAmount?.toLocaleString("fr-FR")} €`;

    confirmDialog({
      message: summaryMessage,
      header: isExistingQuote 
        ? "Confirmation d'association avec devis existant" 
        : "Confirmation de création de nouveau devis",
      icon: "pi pi-question-circle",
      defaultFocus: "reject",
      acceptClassName: "p-button-primary",
      acceptLabel: "Confirmer",
      rejectLabel: "Annuler",
      accept: onConfirm,
      reject: onCancel,
    });
  };

  return { showConfirmDialog };
};
